(function () {
  function initQuoteRotator() {
    document.querySelectorAll('[data-volt-quote-rotator]').forEach(function (container) {
      var quotes = container.querySelectorAll('.volt-qs');
      if (quotes.length < 2) return;

      var index = 0;
      setInterval(function () {
        quotes[index].classList.remove('on');
        index = (index + 1) % quotes.length;
        quotes[index].classList.add('on');
      }, 4500);
    });
  }

  function initReveal() {
    var elements = document.querySelectorAll('.volt-reveal');
    if (!elements.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );

    elements.forEach(function (el) {
      observer.observe(el);
    });
  }

  function initHeaderDropdownHover() {
    if (!window.matchMedia('(min-width: 990px)').matches) return;

    document.querySelectorAll('.volt-header .header__inline-menu .volt-header-menu').forEach(function (menu) {
      var detail = menu.querySelector('details');
      if (!detail) return;

      var summary = detail.querySelector('summary');
      var closeTimer;

      summary.addEventListener('click', function (event) {
        event.preventDefault();
      });

      menu.addEventListener('mouseenter', function () {
        window.clearTimeout(closeTimer);
        detail.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
      });

      menu.addEventListener('mouseleave', function () {
        closeTimer = window.setTimeout(function () {
          detail.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
        }, 150);
      });

      menu.addEventListener('focusin', function () {
        window.clearTimeout(closeTimer);
        detail.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
      });

      menu.addEventListener('focusout', function (event) {
        if (menu.contains(event.relatedTarget)) return;
        closeTimer = window.setTimeout(function () {
          detail.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
        }, 150);
      });
    });
  }

  function initStickyCta() {
    var cta = document.querySelector('[data-volt-sticky-cta]');
    if (!cta) return;

    var threshold = document.body.classList.contains('template-index') ? 560 : 300;

    function updateCta() {
      if (window.scrollY > threshold) {
        cta.classList.add('is-visible');
      } else {
        cta.classList.remove('is-visible');
      }
    }

    updateCta();
    window.addEventListener('scroll', updateCta, { passive: true });
  }

  function initVoltCartCount() {
    var countEls = document.querySelectorAll('[data-volt-cart-count]');
    if (!countEls.length) return;

    function setCount(count) {
      countEls.forEach(function (el) {
        el.textContent = count;
      });
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event.cartData && typeof event.cartData.item_count !== 'undefined') {
          setCount(event.cartData.item_count);
        }
      });
    }

    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble || typeof MutationObserver === 'undefined') return;

    var observer = new MutationObserver(function () {
      var bubbleCount = bubble.querySelector('.cart-count-bubble span[aria-hidden="true"]');
      if (bubbleCount) {
        setCount(parseInt(bubbleCount.textContent, 10) || 0);
        return;
      }

      if (!bubble.querySelector('.cart-count-bubble')) {
        setCount(0);
      }
    });

    observer.observe(bubble, { childList: true, subtree: true });
  }

  function init() {
    initQuoteRotator();
    initReveal();
    initHeaderDropdownHover();
    initStickyCta();
    initVoltCartCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
